import React, { memo } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import BidHistory from './BidHistory'
import TractorDetails from './TractorDetails'
import LoadDescription from './LoadDescription'

const LoadInformation = (props) => {
  const { load, module, activeTab, onBid, onBook, tractorDetails, showMap } = props

  return (
    <>
      <View>
        {activeTab === 'tractor-description'
          ? (
            <TractorDetails
              driver={load?.driver}
              tractor={load?.tractor}
              module={module}
              tractorDetails={tractorDetails}
            />
          ) : activeTab === 'bid-history'
            ? (
              <BidHistory offerHistory={load?.offer_history} />
            ) : (
              <LoadDescription
                module={module}
                load={load}
                onBid={onBid}
                onBook={onBook}
                showMap={showMap}
                tractorDetails={tractorDetails}
              />
            )}
      </View>
    </>
  )
}

LoadInformation.propTypes = {
  load: PropTypes.object,
  module: PropTypes.string,
  activeTab: PropTypes.string,
  onBid: PropTypes.func,
  onBook: PropTypes.func,
  tractorDetails: PropTypes.object,
  showMap: PropTypes.bool
}

const arePropsEqual = (prevProps, nextProps) => {
  return JSON.stringify(prevProps.load) === JSON.stringify(nextProps.load) &&
    prevProps.module === nextProps.module &&
    prevProps.activeTab === nextProps.activeTab
}

export default memo(LoadInformation, arePropsEqual)
